// extracted by mini-css-extract-plugin
export default {"preload":"Loader_preload__rFgTw","preload__bg":"Loader_preload__bg__9Krgh","rotation":"Loader_rotation__A5e6d"};